import React from 'react';
import './Footer.css';

const Footer = () => (
  <footer className="footer">
    From Modul 16 with ❤️
  </footer>
);

export default Footer;